import { ColDef, ColGroupDef } from "ag-grid-community";

export function getPreferredBrandsGenericCategoryConfig(selectedId: string | null): (ColDef<any> | ColGroupDef<any>)[]| null{
    return [
        {
            field: "genericCategoryId",
            hide: true
        },
        {
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 45,
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
        },
        {
            headerName: "Generic Category",
            field: "genericCategoryName",
            minWidth: 200,
            flex: 5,
                cellRendererSelector: (params) => {
                return {
                component: 'baseCellRenderer',
                params: {                                    
                    children:  <div className={ params.data.genericCategoryId == selectedId ? "selected-cell w-100" : ""}>{params.data.genericCategoryName}</div>
                    }
                }
            }
        },
        {
            headerName: "No. of Lines",
            field: "stocks",
            minWidth: 120,
            flex: 2,
        
            cellRendererSelector: (params) => {
            return {
                component: 'baseCellRenderer',
                params: {                    
                    children: params.data?.stocks?.length
                        
                            
                    }

                }
            }
        }
    ]
}